import React, { useState } from "react"
import { Link } from "gatsby"
import { Headline, Button, CirclesBurstSet } from "@shared"
import { css } from "@jsUtils"
import { URLS, CONTENT } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./getInTouch.module.scss"

const { GET_IN_TOUCH } = CONTENT
const { DEFAULT } = GET_IN_TOUCH
const { defHeadline, defSubhead, defCtaCopy } = DEFAULT

/**
 * Podcast section
 * @param {object} props - React props
 */
const GetInTouch = props => {
  const { color, theme, headline, subhead, ctaLink, ctaCopy } = props
  const [ready, setReady] = useState(false)
  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <CirclesBurstSet ready={ready} />
      <div className={Styles.content}>
        <Headline size={1} className={Styles.headline}>
          {headline || defHeadline}
        </Headline>
        <Headline size={5} className={Styles.subhead}>
          {subhead || defSubhead}
        </Headline>
        <Link to={ctaLink || URLS.CONTACT}>
          <Button
            ascope="CTAS"
            adata={{
              content: ctaCopy || defCtaCopy
            }}
            className={Styles.button}
            color={color}
          >
            {ctaCopy || defCtaCopy}
          </Button>
        </Link>
      </div>
    </PageSection>
  )
}

export default GetInTouch
